<div class="synopsis-form">
  <app-dynamic-form
    (onFormLanguageChanged)="onLanguageChanged($event)"
    [formProperties]="formProperties"
    [formGroup]="formGroup"
  >
  </app-dynamic-form>
  <app-loading *ngIf="postSynopsisLoading$ | async"></app-loading>
  <div class="toolbar">
    <sui-button
      *ngIf="!hasSynopsisLanguage"
      variant="primary"
      [leadingIcon]="['fas', 'plus']"
      (click)="createSynopsis()"
    >
      {{ "btn.create" | translate }}
    </sui-button>

    <sui-button
      *ngIf="hasSynopsisLanguage"
      variant="primary"
      [leadingIcon]="['fas', 'edit']"
      (click)="updateSynopsis()"
    >
      {{ "btn.update" | translate }}
    </sui-button>
    <sui-button
      variant="primary"
      [leadingIcon]="['fas', 'wand-magic-sparkles']"
      (click)="aiGenerateSynopsis()"
    >
      {{ "post.sypnosis.button.ai-generate" | translate }}
    </sui-button>
    <sui-button
      variant="secondary"
      [leadingIcon]="['fas', 'copy']"
      (click)="copyFromOriginal()"
    >
      {{ "post.sypnosis.button.copy-from-original" | translate }}
    </sui-button>
    @if (post.has_translation) {
      <sui-button
        variant="secondary"
        [leadingIcon]="['fas', 'copy']"
        (click)="copyFromTranslation()"
      >
        {{ "post.sypnosis.button.copy-from-translation" | translate }}
      </sui-button>
    }
    @if (hasSynopsisLanguage) {
      <sui-button
        variant="danger"
        [leadingIcon]="['fas', 'trash']"
        (click)="deleteSynopsis()"
      >
        {{ "btn.delete" | translate }}
      </sui-button>
    }
  </div>
</div>
